"use client";
import * as React from "react";
const SvgShoppingCartRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.8 12.8c-.88 0-1.592.72-1.592 1.6 0 .88.712 1.6 1.592 1.6.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6ZM0 0v1.6h1.6l2.88 6.072-1.08 1.96c-.128.224-.2.488-.2.768 0 .88.72 1.6 1.6 1.6h9.6v-1.6H5.136a.198.198 0 0 1-.2-.2l.024-.096.72-1.304h5.96c.6 0 1.128-.328 1.4-.824l2.864-5.192A.802.802 0 0 0 15.2 1.6H3.368L2.616 0H0Zm12.8 12.8c-.88 0-1.592.72-1.592 1.6 0 .88.712 1.6 1.592 1.6.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6Z" }));
export {
  SvgShoppingCartRound as default
};
